export default {
  table: {
    menuName: "菜单名称",
    path: "路由路径",
    componentPath: "组件路径",
    interfacePath: "api接口",
    hidden: "显示状态",
    show: "显示",
    hide: "隐藏",
    type: "类型",
    catalogue: "目录",
    menu: "菜单",
    btn: "按钮",
    isLogRecord: "是否记录日志",
  },
  dialog: {
    parent: "上级菜单",
    redirect: "重定向",
    icon: "图标",
    role: "角色",
    menuInternationalization: "国际化",
    logRecord: "记录日志",
  },
};
